import Button from "@/components/atom/Button";
import Input, { Caption } from "@/components/atom/Input";
import {
  getGroupArea,
  revalidateCustom,
  updateProfileSaya,
} from "@/functions/databaseData";
import handleErrorAPI from "@/functions/handleErrorAPI";
import checkLevel from "@/functions/checkLevel";
import { CalendarOutlineSvg, PenEditSvg } from "@/public/svg";
import phone from "phone";
import React, { useCallback, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import { toast } from "react-toastify";
import { usePathname } from "next/navigation";

const settingToast = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export default function InfoPribadiAlamat({
  profile,
  handleChange,
  handleChangeError,
  forms,
  errors,
  setErrors,
  setForms,
  token,
}) {
  const path = usePathname();
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState({
    key: false,
  });
  const [area, setArea] = useState({
    province: [],
    city: [],
    district: [],
    sub_district: [],
  });
  const [disable, setDisable] = useState({
    infoPribadi: true,
    infoAlamat: true,
  });

  function clear(type) {
    setErrors({});
    setDisable((old) => ({ ...old, [type]: true }));
    setForms((old) => ({ ...old, alamat: {} }));
  }

  const handleSave = async (type = "infoPribadi") => {
    try {
      if (type === "infoPribadi") {
        if (
          !phone(
            !forms?.telephone?.startsWith("+")
              ? `+${forms?.telephone}`
              : forms?.telephone
          )?.isValid
        ) {
          handleChangeError("telephone")("No Telephone tidak valid");
          return;
        }
      }
      if (type === "infoAlamat") {
        if (
          !forms?.alamat?.provinsi ||
          !forms?.alamat?.kabupaten ||
          !forms?.alamat?.kecamatan ||
          !forms?.alamat?.kelurahan
        ) {
          handleChangeError("alamat")("Lengkapi alamat");
          return;
        }
      }

      const event = type === "infoPribadi" ? "personal" : "address";

      const coordinates =
        !profile?.address_information?.location?.latitude ||
        !profile?.address_information?.location?.longitude
          ? {
              latitude: 0,
              longitude: 0,
            }
          : {
              latitude: profile?.address_information?.location?.latitude,
              longitude: profile?.address_information?.location?.longitude,
            };

      const countChange = profile.max_cange_info_address;
      const res = await updateProfileSaya(
        event == "address"
          ? {
              id: profile?.mitra_id,
              body: {
                ...forms,
                gender: forms?.gender?.id,
                area_id: forms?.alamat?.kelurahan?.id,
                ...coordinates,
              },
              token,
              url_api:
              countChange > 0 && profile?.mitra_level == 1
                  ? `mitra/${profile?.mitra_id}/request/update_profile?event=address`
                  : `mitra/${profile?.mitra_id}/update?event=address`,
            }
          : {
              id: profile?.mitra_id,
              body: {
                ...forms,
                gender: forms?.gender?.id,
                area_id: forms?.alamat?.kelurahan?.id,
                ...coordinates,
              },
              event,
              token,
            }
      );
      if (!res.error) {
        clear(type);
        revalidateCustom({
          path,
        });
        return countChange > 0 && profile?.mitra_level == 1
          ? toast.info("Menunggu approval dari admin untuk perubahan alamat", {
              position: "top-center",
            })
          : toast.success(`Success melakukan update ${type}`, {
              position: "top-center",
            });
      } else {
        if (
          res.error.message.includes(
            "Sorry, requests to change personal information data can no longer be done, please contact CS"
          )
        )
          throw new Error(res.error.message ?? res.error);

        handleErrorAPI(res.error, setErrors, [
          "username",
          "date_of_birth",
          "telephone",
          "gender",
          "address",
        ]);
      }
    } catch (error) {
      toast.error(error.message, { position: "top-center" });
    }
  };

  function handleDropdown(state) {
    setShowDropdown((old) => ({ ...old, [state]: !showDropdown?.[state] }));
  }

  useEffect(() => {
    run();
  }, [
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan,
  ]);

  const run = useCallback(async () => {
    try {
      const payload = {
        province: forms?.alamat?.provinsi?.id,
        city: forms?.alamat?.kabupaten,
        district: forms?.alamat?.kecamatan,
      };
      !forms?.alamat?.provinsi?.id && delete payload?.province;
      !forms?.alamat?.kabupaten && delete payload?.city;
      !forms?.alamat?.kecamatan && delete payload?.district;

      const data_area = await getGroupArea(payload);
      const thisvalue =
        area?.province?.length <= 0
          ? "province"
          : area?.city?.length <= 0
          ? "city"
          : area?.district?.length <= 0
          ? "district"
          : "sub_district";
      setArea((old) => ({ ...old, [thisvalue]: data_area }));
    } catch (error) {
      console.log(error.messgae);
    }
  }, [
    area,
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan,
  ]);

  const filterTextArea = {
    province: forms?.alamat?.provinsi?.title,
    city: forms?.alamat?.kabupaten,
    district: forms?.alamat?.kecamatan,
    sub_district: forms?.alamat?.kelurahan?.title,
  };

  const isArea = (params) => {
    return area?.[params]
      ?.map((item, index) => ({
        id: item?.province_id
          ? item?.province_id
          : item?.area_id
          ? item?.area_id
          : index,
        title: item?.province_name
          ? item?.province_name
          : item?.city_name
          ? item?.city_name
          : item?.district_name
          ? item?.district_name
          : item?.subdistrict_name,
      }))
      .filter((item) =>
        !filterTextArea?.[params]
          ? item
          : item?.title
              .toLowerCase()
              ?.includes(filterTextArea?.[params]?.toLowerCase())
      );
  };

  const listFormPribadi = [
    {
      key: "username",
      fieldDB: "username",
      label: "Nama Lengkap",
      typeInput: "text",
    },
    {
      key: "mitra_level",
      fieldDB: "mitra_level",
      placeholder: checkLevel(profile?.mitra_level),
      label: "Level Kemitraan",
      typeInput: "text",
      disable: true,
    },
    {
      key: "date_of_birth",
      fieldDB: "date_of_birth",
      label: "Tanggal Lahir",
      typeInput: "date",
    },
    {
      key: "telephone",
      fieldDB: "telephone",
      label: "Nomor HP",
      typeInput: "text",
    },
    {
      key: "gender",
      fieldDB: "gender",
      label: "Jenis Kelamin",
      variants: "dropdown",
      handleDropdown: {
        datas: [
          {
            id: "L",
            title: "Laki-Laki",
          },
          {
            id: "P",
            title: "Perempuan",
          },
        ],
        show: showDropdown?.gender,
        showHIdden: () => handleDropdown(`gender`),
        onChange: (value) => handleChange("gender")(value),
        value: forms?.gender,
      },
    },
  ];

  const listFormAlamat = [
    {
      key: "provinsi",
      keyArea: "province",
      placeholder: profile?.address_information?.province_name,
      label: "Provinsi",
      valueDropdown: forms?.alamat?.provinsi?.title,
      zIndex: 5,
      defaultState: {
        id: 0,
        title: "",
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
        };
      },
      alamatFieldKosong: {
        kabupaten: "",
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        city: [],
        district: [],
        sub_district: [],
      },
    },
    {
      key: "kabupaten",
      keyArea: "city",
      disabled: !forms?.alamat?.provinsi,
      placeholder: profile?.address_information?.city_name,
      label: "Kabupaten",
      valueDropdown: forms?.alamat?.kabupaten,
      zIndex: 4,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        district: [],
        sub_district: [],
      },
    },
    {
      key: "kecamatan",
      keyArea: "district",
      disabled: !forms?.alamat?.kabupaten,
      placeholder: profile?.address_information?.district_name,
      label: "Kecamatan",
      valueDropdown: forms?.alamat?.kecamatan,
      zIndex: 3,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        sub_district: [],
      },
    },
    {
      key: "kelurahan",
      keyArea: "sub_district",
      disabled: !forms?.alamat?.kecamatan,
      placeholder: profile?.address_information?.subdistrict_name,
      label: "Kelurahan",
      valueDropdown: forms?.alamat?.kelurahan?.title,
      zIndex: 2,
      defaultState: {
        id: 0,
        title: "",
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
        };
      },
      alamatFieldKosong: {},
      areaFieldKosong: {},
    },
  ];

  return (
    <div className="flex md:flex-row flex-col gap-4">
      <div className="flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 gap-4 xs:p-8 xs:gap-8">
        <div className="flex flex-col xs:flex-row gap-4 justify-between">
          <p className="subheading-semiBold text-greyscaleGON-400">
            Informasi Pribadi
          </p>
          {disable?.infoPribadi ? (
            <Button
              label="ubah"
              icon={{
                left: (props) => <PenEditSvg className={props.className} />,
              }}
              size="small"
              variants="outline"
              onClick={() =>
                setDisable((old) => ({ ...old, infoPribadi: false }))
              }
            />
          ) : (
            <div className="flex flex-col-reverse xs:flex-row gap-4 items-center">
              <Button
                label="batal"
                size="small"
                variants="outline"
                onClick={() => clear("infoPribadi")}
                className="flex w-full xs:w-auto"
              />
              <Button
                label="simpan"
                size="small"
                onClick={() => handleSave("infoPribadi")}
                className="flex w-full xs:w-auto"
              />
            </div>
          )}
        </div>
        <div className="relative flex flex-col gap-4">
          {listFormPribadi?.map((item, index) => (
            <React.Fragment key={index}>
              <Input
                onSubmit={() => handleSave("infoPribadi")}
                onChange={handleChange(item?.key)}
                value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
                disabled={item?.disable ?? disable?.infoPribadi}
                placeholder={item?.placeholder ?? profile?.[item?.fieldDB]}
                label={item?.label}
                error={
                  (!errors?.[item?.key] ? false : true) ||
                  (!forms?.[item?.key] && item?.key !== "mitra_level")
                }
                caption={
                  errors?.[item?.key] ||
                  (!forms?.[item?.key] && item?.key !== "mitra_level")
                    ? errors?.[item?.key] ?? "data not found"
                    : ""
                }
                type={item?.typeInput}
                variants={item?.variants}
                handleDropdown={item?.handleDropdown}
                icon={item?.handleIcon}
              />
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className=" flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 gap-4 xs:p-8 xs:gap-8">
        <div className="flex flex-col xs:flex-row gap-4 justify-between">
          <p className="subheading-semiBold text-greyscaleGON-400">
            Informasi Alamat
          </p>
          {disable?.infoAlamat ? (
            <Button
              label="ubah"
              icon={{
                left: (props) => <PenEditSvg className={props.className} />,
              }}
              onClick={() => {
                setDisable((old) => ({ ...old, infoAlamat: false }));
                setForms((old) => ({ ...old, alamat: {} }));
              }}
              size="small"
              variants="outline"
            />
          ) : (
            <div className="flex flex-col-reverse xs:flex-row gap-4 items-center">
              <Button
                label="batal"
                size="small"
                variants="outline"
                onClick={() => clear("infoAlamat")}
                className="flex w-full xs:w-auto"
              />
              <Button
                label="simpan"
                size="small"
                onClick={() => handleSave("infoAlamat")}
                className="flex w-full xs:w-auto"
              />
            </div>
          )}
        </div>
        {(errors?.alamat?.length > 0 ||
          !profile?.address_information?.postal_code) && (
          <p className="text-errorGON-400 text-button-medium">
            *
            {!profile?.address_information?.postal_code
              ? "lengkapi informasi alamat"
              : errors?.alamat}
          </p>
        )}
        <div className="flex flex-col gap-4">
          {listFormAlamat?.map((item, index) => (
            <div
              key={index}
              className={twMerge(`z-[${item?.zIndex}]`, "flex flex-col gap-2")}
            >
              <Input
                onSubmit={() => handleSave("infoAlamat")}
                value={item?.valueDropdown}
                placeholder={item?.placeholder}
                disabled={item?.disabled || disable?.infoAlamat}
                label={item?.label}
                onChange={(value) => {
                  setForms((old) => ({
                    ...old,
                    alamat: {
                      ...old?.alamat,
                      [item?.key]: item?.changeState(value),
                    },
                  }));
                }}
                size="small"
                variants="dropdown"
                handleDropdown={{
                  show: showDropdown?.[`alamat_${item?.key}`],
                  showHIdden: () => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        [item?.key]: item?.defaultState,
                      },
                    }));
                    handleDropdown(`alamat_${item?.key}`);
                  },
                  datas: isArea(item?.keyArea),
                  onChange: (value) => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        ...item?.alamatFieldKosong,
                        [item?.key]: item?.changeState(value),
                      },
                    }));
                    setArea((old) => ({
                      ...old,
                      ...item?.areaFieldKosong,
                    }));
                  },
                  value: item?.valueDropdown,
                }}
              />
            </div>
          ))}
          {/* Detail Alamat */}
          <Input
            onSubmit={() => handleSave("infoAlamat")}
            onChange={handleChange("address")}
            value={forms?.address}
            placeholder={profile?.address_information?.address ?? "-"}
            label={"Detail Alamat"}
            variants="textarea"
            disabled={!forms?.alamat?.kelurahan || disable?.infoAlamat}
            error={!errors?.address ? false : true}
            caption={errors?.address}
          />
        </div>
      </div>
    </div>
  );
}
